import React from 'react';
import Link from '../../../../../theme/components/Link';
import { getPolyglot } from '../../../../../i18n';
import { StyledMenuItemPrimary } from '../AvatarMenu';

export const AvatarLinks = (props: {
  urlAboutUs: string;
  urlStatus: string;
}) => {
  const { urlAboutUs, urlStatus } = props;
  const polyglot = getPolyglot();

  return (
    <>
      <Link to={urlAboutUs} target="_blank">
        <StyledMenuItemPrimary>
          {polyglot.t('footer.about_us')}
        </StyledMenuItemPrimary>
      </Link>
      <Link to="/terms-and-conditions">
        <StyledMenuItemPrimary>
          {polyglot.t('footer.terms_and_conditions')}
        </StyledMenuItemPrimary>
      </Link>
      <Link to="/cookies">
        <StyledMenuItemPrimary>
          {polyglot.t('footer.cookie_policy')}
        </StyledMenuItemPrimary>
      </Link>
      <Link to="/privacy">
        <StyledMenuItemPrimary>
          {polyglot.t('footer.privacy_policy')}
        </StyledMenuItemPrimary>
      </Link>
      <Link to="/impressum">
        <StyledMenuItemPrimary>
          {polyglot.t('footer.impressum')}
        </StyledMenuItemPrimary>
      </Link>
      <Link to={urlStatus} target="_blank">
        <StyledMenuItemPrimary>
          {polyglot.t('footer.status')}
        </StyledMenuItemPrimary>
      </Link>
    </>
  );
};
